import {
    EButtonLinkType,
    EHorizontalPosition,
    EMenuLayoutType,
    EMenuLogoPosition,
    ESize,
    Widgets,
} from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import { type WebWidgetModel } from '@web/types';
import { type MenuWidgetData } from '@web/widgets/menu/type/menu-widget.type';

import { MenuViewComponent } from '@web/widgets/menu/components/menu-view/menu-view.component';
import { MenuControlComponent } from '@web/widgets/menu/components/menu-control/menu-control.component';
import { EffectTypes } from '@web/shared/components/web-hover-effects/types';
import { ThemeColorNames } from '@sites/site-theme/src/enums/color-names.enum';
import { createId } from '@paralleldrive/cuid2';
import { defaultWidgetDataAdapter } from '@common/helpers';
import { type TranslateService } from '@ngx-translate/core';

// DEFAULT COMPONENT SETTINGS
const menuData = (): MenuWidgetData => ({
    isLogo: false,
    uploadImage: null,
    logoPosition: EMenuLogoPosition.LEFT,
    menuList: [
        {
            name: 'Home',
            linkUrl: 'https://example.com',
            linkType: EButtonLinkType.link,
            isVisible: true,
            id: createId(),
        },
        {
            name: 'Phone',
            linkUrl: '0501111111',
            linkType: EButtonLinkType.phone,
            isVisible: true,
            id: createId(),
        },
        {
            name: 'Learn more',
            linkUrl: 'id-568222',
            linkType: EButtonLinkType.anchor,
            isVisible: false,
            id: createId(),
        },
    ],
    textColor: '#1b1b1b',
    submenuTextColor: '#1b1b1b',
    themeTextColor: null,
    fontSize: 16,
    submenuFontSize: 16,
    menuItemIndent: ESize.S,
    horizontalPosition: EHorizontalPosition.L,
    layoutDirection: EMenuLayoutType.HORIZONTAL,
    fontStile: [],
    submenuFontStile: [],
    submenuListBackground: '#fff',
    showIconOnMobile: true,
    iconColor: '#1b1b1b',
    iconPosition: EHorizontalPosition.L,
    iconSize: ESize.M,
    hoverEffects: {
        type: EffectTypes.transparency,
        transparency: 80,
        lineWidth: 1,
        color: ThemeColorNames.primary,
        lineType: 'solid',
        animationType: 'moving_up',
    },
    isSynchronizeStyle: true,
    hideOnMobile: false,
    hideOnTablet: false,
    hideOnDesktop: false,
    position: {
        width: 100,

        x: 0,
        y: 0,
        rotate: 0,
        zIndex: 0,
        mobileX: 0,
        mobileY: 0,
        mobileRotate: 0,
        mobileZIndex: 0,
    },
});
// END DEFAULT SETTINGS

export const menuWidgetModel: WebWidgetModel = {
    componentView: MenuViewComponent,
    componentControl: MenuControlComponent,
    name: Widgets.MENU,
    label: 'widget_menu_label',
    data: menuData,
    permission: defaultWidgetPermission,
    params: defaultWidgetParams,
    dataAdapter: (data: any, modelData: MenuWidgetData) => {
        const adaptedData: MenuWidgetData = defaultWidgetDataAdapter(data, modelData);

        adaptedData.menuList = adaptedData.menuList.map((el) => {
            if (!el.id) {
                return {
                    ...el,
                    id: createId(),
                };
            }

            return el;
        });

        return adaptedData;
    },
};
